import React, { FC, useEffect } from 'react'

import { GlobalModelState } from '@/models/connect'
import { Dispatch, Loading, connect } from 'umi'
import FirstLevelMenu from './components/firstLevelMenu'

export interface BasicLayoutProps {
	dispatch: Dispatch
	global: GlobalModelState
	loading: boolean
	hasSubMenu?: boolean // 是否展示二级菜单
}

const MenuContent: FC<BasicLayoutProps> = ({
	dispatch,
	global,
	hasSubMenu,
}) => {
	useEffect(() => {
		dispatch({
			type: 'global/getUserMenuList',
		})
	}, [])

	return <FirstLevelMenu />
}

export default connect(
	({ global, loading }: { global: GlobalModelState; loading: Loading }) => ({
		global,
		loading: loading.models.index,
	}),
)(MenuContent)
